import { Component, OnInit } from '@angular/core';
import { SharingService } from '../../services/sharing.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {

  constructor(private sharingObservable: SharingService,) { }

  data: any;

  ngOnInit() {
    this.sharingObservable.sharingObservable.subscribe((e: any) => {
      this.data = JSON.parse(e);
    });

  }

  ngAfterViewInit() {
    let form = <HTMLFormElement>document.getElementById('payForm');

    form.submit();
  }
}
